import AbstractCommand from "../../app/core/AbstractCommand";
import PlatformAPIEventType from "./PlatformAPIEventType";
import PlatformAPIService from "./PlatformAPIService";

export default class PlatformAPICommand extends AbstractCommand {

    /**    
     * @param {PlatformAPIService} platformAPIService 
     */
    constructor(platformAPIService) {
        super();

        this.execute = function({ type, params }) {
            switch (type) {
                case PlatformAPIEventType.PROGRESS:
                    platformAPIService.sendProgressEvent(params.progressValue, params.elapsedTime);
                    break;
                case PlatformAPIEventType.INTERACTION:
                    platformAPIService.sendInteractionEvent(params.eventName, params.eventParams, params.elapsedTime);
                    break;
                case PlatformAPIEventType.SAVE_REQUEST:
                    platformAPIService.save(params.state);
                    break;
            }
        }
    }
}
